export const SCATTER_PLOT = {
  key: 'scatterGraph',
  label: 'Scatter Graph'
};